export function emailValidation (emailToTest) {
  const regexp = /\S+@\S+\.\S+/

  return regexp.test(String(emailToTest).toLowerCase())
}
